/** QuickHouse — Barre de statut */
import { useProjectStore } from '../store/useProjectStore.js';

export default function StatusBar() {
  const statusText = useProjectStore((s) => s.statusText);
  const project = useProjectStore((s) => s.project);
  const activeFloorId = useProjectStore((s) => s.activeFloorId);
  const floor = project?.floors.find((f) => f.id === activeFloorId);

  return (
    <div className="statusbar">
      {floor && <span>{floor.name} — {floor.walls.length} murs, {floor.openings.length} ouvertures</span>}
      <span>{statusText}</span>
    </div>
  );
}
